import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.ROUTER_BASE,
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      redirect: '/21dljnhs'
    },
    {
      path: '/21dljnhs',
      name: '21dljnhs',
      component: () => import('@/views/dljnhs/index'),
      meta: {
        pageTitle: '首页'
      }
    },
    {
      path: '/picshow',
      name: 'picshow',
      component: () => import('@/views/dlsong/picshow'),
      meta: {
        pageTitle: '复赛展示'
      }
    },
    {
      path: '/intro',
      name: 'intro',
      component: () => import('@/views/dlsong/intro'),
      meta: {
        pageTitle: '活动介绍'
      }
    },
    {
      path: '/rank',
      name: 'rank',
      component: () => import('@/views/dlsong/rank'),
      meta: {
        pageTitle: '排行榜'
      }
    },
    {
      path: '/dljnhs_detail/:operateCode/:ocCode/:ocName/:searchSort',
      name: 'dljnhs_detail',
      component: () => import('@/views/dljnhs/dljnhs_detail'),
      meta: {
        pageTitle: '书法详情'
      }
    },
    {
      path: '/getaward',
      name: 'getaward',
      component: () => import('@/views/dlsong/getaward'),
      meta: {
        pageTitle: '决赛展示'
      }
    },
    {
      path: '/getprice',
      name: 'getprice',
      component: () => import('@/views/dlsong/getprice'),
      meta: {
        pageTitle: '获奖公示'
      }
    },
    {
      path: '/getnetmoods',
      name: 'getnetmoods',
      component: () => import('@/views/dlsong/getprice1'),
      meta: {
        pageTitle: '网络人气奖公示'
      }
    },
    {
      path: '/getexpertmoods',
      name: 'getexpertmoods',
      component: () => import('@/views/dlsong/getprice2'),
      meta: {
        pageTitle: '专家奖公示'
      }
    },
    {
      path: '/getexcellent',
      name: 'getexcellent',
      component: () => import('@/views/dlsong/getprice3'),
      meta: {
        pageTitle: '优秀奖公示'
      }
    }

    // {
    //   path: '/worksubmit',
    //   name: 'worksubmit',
    //   component: () => import('@/views/hzgsds/worksubmit/index'),
    //   meta: {
    //     pageTitle: '作品投稿'
    //   }
    // },
    // {
    //   path: '/act_detail/:id',
    //   name: 'act_detail',
    //   component: () => import('@/views/hzgsds/act_detail/index'),
    //   meta: {
    //     pageTitle: '作品详情'
    //   }
    // },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js